import React, { useState } from "react"
import "./Clients.css"
import icon1 from "../assets/icon-1.png"
import icon2 from "../assets/icon-2.png"
import icon3 from "../assets/icon-3.png"
import icon4 from "../assets/icon-4.png"
import icon5 from "../assets/icon-5.png"
import icon6 from "../assets/icon-6.png"
import icon7 from "../assets/icon-7.png"
import icon8 from "../assets/icon-8.png"
import icon9 from "../assets/icon-9.png"
import icon10 from "../assets/icon-10.png"
import icon11 from "../assets/icon-11.png"
import { useTranslation } from "react-i18next"



const Clients = () => {

  const { t, i18n } = useTranslation()
  const [activeIndex, setActiveIndex] = useState(null);

  const toggleActive = (index) => {
    setActiveIndex((prev) => (prev === index ? null : index));
  };

  const icons = [
    { id: 1, src: icon1, alt: `${t('home.clients.circle_clients.client_1')}` },
    { id: 2, src: icon2, alt: `${t('home.clients.circle_clients.client_2')}` },
    { id: 3, src: icon3, alt: `${t('home.clients.circle_clients.client_3')}` },
    { id: 4, src: icon4, alt: `${t('home.clients.circle_clients.client_4')}` },
    { id: 5, src: icon5, alt: `${t('home.clients.circle_clients.client_5')}` },
    { id: 6, src: icon6, alt: `${t('home.clients.circle_clients.client_6')}` },
    { id: 7, src: icon7, alt: `${t('home.clients.circle_clients.client_7')}` },
    { id: 8, src: icon8, alt: `${t('home.clients.circle_clients.client_8')}` },
    { id: 9, src: icon9, alt: `${t('home.clients.circle_clients.client_9')}` },
    { id: 10, src: icon10, alt: `${t('home.clients.circle_clients.client_10')}` },
    { id: 11, src: icon11, alt: `${t('home.clients.circle_clients.client_11')}` },
  ];

  return (
    <section className="clients-section">
      <div className="clients-header">
        <span className="mini-title">{t('home.clients.title_card')}</span>
        <p className="section-main-subtitle-clients">{t('home.clients.main_title')}</p>
      </div>

      <div style={{ "--total": icons.length }} className="circle-container">
        {activeIndex !== null && (
          <div className="client-name">{icons[activeIndex].alt}</div>
        )}

        <div className={`center-circle ${activeIndex !== null ? "hidden" : ""}`}>
          {t('home.clients.circle_clients.title')}
        </div>

        <div className="icon-circle">
          {icons.map((icon, i) => {
            const isActive = activeIndex === i;
            return (
              <div
                key={icon.id}
                className={`avatar ${isActive ? "active" : ""}`}
                style={{ "--i": i + 1 }}
                onClick={() => toggleActive(i)}
                title={icon.alt}
              >
                <img src={icon.src} alt={icon.alt} />
              </div>
            );
          })}
        </div>
      </div>
    </section>
  )
}

export default Clients